<template>
<div class="page-container">
  <page-header></page-header>
  <page-table ref="table" show-paginate :get-data="adminPage" :fields="fields" :search-model="searchModel"
              :item-actions="actions" @onActionClick="handleItemActionClick">
    <template slot="search-items">
      <el-form-item label="姓名" prop="realname">
        <el-input v-model="searchModel.realname" placeholder="姓名"></el-input>
      </el-form-item>
      <el-form-item label="用户名" prop="username">
        <el-input v-model="searchModel.username" placeholder="用户名"></el-input>
      </el-form-item>
    </template>
    <template slot="page-actions">
      <el-button @click="handleTemplate" icon="el-icon-download" size="mini" type="primary">导入模板</el-button>
      <el-upload action="-" accept="xls,xlsx" :http-request="handleImport"
                 :show-file-list="false" style="margin: 0 10px;">
        <el-button class="option" icon="el-icon-upload" size="mini" type="primary">导入用户</el-button>
      </el-upload>
      <el-button @click="handleAdd" icon="el-icon-plus" size="mini" type="primary">新建</el-button>
    </template>
  </page-table>

  <!--导入失败显示-->
  <el-dialog title="导入失败数据" fullscreen :visible.sync="failImportVisible" center :close-on-click-modal="false">
    <table v-if="failImportData"
           border="1" cellpadding="10"
           style="border-collapse: collapse;text-align: center;width: auto; margin: 0 auto;">
      <tr>
        <th v-for="(headerT,indexH) in failImportData.headers" :key="indexH"
            style="padding: 10px 20px;">{{ headerT }}
        </th>
      </tr>
      <tr v-for="(rows,indexR) in failImportData.fail_rows" :key="indexR">
        <td v-for="(row,indexR1) in rows" :key="indexR1" style="padding: 10px 20px;">
          {{ row }}
        </td>
      </tr>
    </table>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="failImportVisible = false">关闭</el-button>
    </div>
  </el-dialog>


</div>
</template>

<script>
import PageHeader from "@/components/PageHeader"
import PageTable from "@/components/PageTable"
import {adminImport, adminPage} from "@/api/auth"

export default {
  name: "Admins",
  data() {
    return {
      form_loading: false,
      searchModel: {
        realname: '',
        username: '',
      },
      adminPage: adminPage,
      fields: [
        {label: '#', key: 'id', sortable: true, width: 80},
        {label: '姓名', key: 'realname', width: 140, align: 'center'},
        {label: '用户名', key: 'username', width: 140, align: 'center'},
        {label: '手机', key: 'mobile', width: 130, align: 'center'},
        {label: '邮箱', key: 'email', width: 180, align: 'center'},
        {
          label: '是否激活',
          width: 120,
          render: ({is_active}, h) => {
            return h('span', {
              attrs: {
                class: is_active ? 'bool-true' : 'bool-false'
              }
            }, is_active ? '是' : '否')
          },
        },
        {
          label: '汽车权限',
          width: 120,
          render: ({has_car_permission}, h) => {
            return h('span', {
              attrs: {
                class: has_car_permission ? 'bool-true' : 'bool-false'
              }
            }, has_car_permission ? '是' : '否')
          },
        },
        {
          label: '巴士权限',
          width: 120,
          render: ({has_bus_permission}, h) => {
            return h('span', {
              attrs: {
                class: has_bus_permission ? 'bool-true' : 'bool-false'
              }
            }, has_bus_permission ? '是' : '否')
          },
        },
        {label: '上次登录', key: 'last_login_at', width: 160, align: 'center'},
        {label: '上次运行', key: 'last_stopped_at', width: 160, align: 'center'},
        {label: '创建时间', key: 'created_at', width: 160, align: 'center'},
        {label: '修改时间', key: 'updated_at', width: 160, align: 'center'},
      ],
      actions: [
        {
          action: 'edit', label: '编辑', type: 'primary',
          showAction: admin => {
            return !admin.is_supper_admin
          }
        },
      ],
      //导入
      failImportVisible: false,
      failImportData: null,
    }
  },
  components: {
    PageHeader,
    PageTable
  },
  created() {

  },
  mounted() {

  },
  activated() {
    this.$refs.table && this.$refs.table.loadData()
  },
  methods: {
    handleItemActionClick(action, item) {
      let that = this
      that[action + 'Action'](item)
    },
    handleAdd() {
      this.$router.push({path: '/createAdmin'})
    },
    editAction(item) {
      this.$router.push({path: '/admins/' + item.id})
    },
    handleTemplate() {
      location.href = "/templates/用户导入模板.xlsx";
    },
    handleImport(source) {
      let that = this
      let loadingInstance = that.$loading({})
      adminImport(source.file).then(res => {
        loadingInstance.close()
        that.$refs.table.loadData()
        // 有导入失败的数据
        if (res.fail_rows.length) {
          that.failImportVisible = true
          that.failImportData = res
        } else {
          that.$message.success('导入成功')
        }
      }).catch(() => {
        loadingInstance.close()
      })
    },
  },
}
</script>

<style lang="scss" scoped>

</style>
